import React from "react"
import { Col, Drawer, Form, Input, Row, Select } from "antd"
import { Button } from "src/components/actions/button"
import { CloseSvg, RotateClockwiseSvg, SaveSvg } from "src/components/Svg"
import { useAppData } from "src/store/app-data"
import styled from "styled-components"

export function EditDrawer({
  title,
  initialValues,
  onClose,
  onSave,
  permissionOptions,
}) {
  const layoutConfig = useAppData((state) => state.layoutConfig)
  const [form] = Form.useForm()

  React.useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues)
    }
  }, [initialValues])

  async function onSubmit(values) {
    await onSave(values)
    onClose()
    form.resetFields()
  }

  function handleClose() {
    onClose()
    form.resetFields()
  }

  const id = initialValues?.id ?? "new"

  return (
    <DrawerEdit
      width={layoutConfig.isMobile ? "90%" : "50%"}
      title={title}
      onClose={handleClose}
      open
    >
      <FormEdit
        form={form}
        layout={"vertical"}
        onFinish={(values) => onSubmit(values)}
      >
        <StyledFormItem
          key={id + "_name"}
          label={"Название"}
          name={"name"}
          rules={[
            {
              required: true,
              message: "Введите название!",
            },
          ]}
        >
          <Input placeholder={"Название роли"} />
        </StyledFormItem>

        <StyledFormItem
          key={id + "_slug"}
          label={"Slug"}
          name={"slug"}
          rules={[
            {
              required: true,
              message: "Введите slug!",
            },
          ]}
        >
          <Input placeholder={"slug роли"} />
        </StyledFormItem>

        <StyledFormItem
          key={id + "_permissionIds"}
          label={
            <Row justify="space-between" align="middle" style={{ width: "100%" }}>
              <span>Разрешения</span>
              <Button
                size="small"
                type="link"
                onClick={() => {
                  const allIds = permissionOptions.map((o) => o.value)
                  form.setFieldsValue({ permissionIds: allIds })
                }}
              >
                Выбрать все
              </Button>
            </Row>
          }
          name={"permissionIds"}
        >
          <Select
            mode="multiple"
            allowClear
            placeholder={"Выберите разрешения"}
            options={permissionOptions}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        </StyledFormItem>

        <ButtonRow>
          <ButtonCol>
            <Button
              danger
              onClick={() => {
                if (initialValues) {
                  form.setFieldsValue(initialValues)
                  return
                }
                form.resetFields()
              }}
              icon={<RotateClockwiseSvg />}
            >
              Вернуть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button onClick={handleClose} icon={<CloseSvg />}>
              Закрыть
            </Button>
          </ButtonCol>
          <ButtonCol>
            <Button icon={<SaveSvg />} type="primary" htmlType="submit">
              Сохранить
            </Button>
          </ButtonCol>
        </ButtonRow>
      </FormEdit>
    </DrawerEdit>
  )
}

const DrawerEdit = styled(Drawer)``

const FormEdit = styled(Form)``

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 16px;
`

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`
